/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './dosage-guideline.reducer';

export const DosageGuideline = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const dosageGuidelineList = useAppSelector(state => state.dosageGuideline.entities);
  const loading = useAppSelector(state => state.dosageGuideline.loading);
  const totalItems = useAppSelector(state => state.dosageGuideline.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="dosage-guideline-heading" data-cy="DosageGuidelineHeading">
        <Translate contentKey="tinyMedicRestApp.dosageGuideline.home.title">Dosage Guidelines</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.dosageGuideline.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/dosage-guideline/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.dosageGuideline.home.createLabel">Create new Dosage Guideline</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.dosageGuideline.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {dosageGuidelineList && dosageGuidelineList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('dosageValue')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.dosageValue">Dosage Value</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dosageValue')} />
                </th>
                <th className="hand" onClick={sort('dosageUnit')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.dosageUnit">Dosage Unit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dosageUnit')} />
                </th>
                <th className="hand" onClick={sort('recommendedDosage')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.recommendedDosage">Recommended Dosage</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recommendedDosage')} />
                </th>
                <th className="hand" onClick={sort('administrationRoute')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.administrationRoute">Administration Route</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('administrationRoute')} />
                </th>
                <th className="hand" onClick={sort('specialInstructions')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.specialInstructions">Special Instructions</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('specialInstructions')} />
                </th>
                <th className="hand" onClick={sort('asNeeded')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.asNeeded">As Needed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('asNeeded')} />
                </th>
                <th className="hand" onClick={sort('asNeededCondition')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.asNeededCondition">As Needed Condition</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('asNeededCondition')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.dosageGuideline.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dosageGuidelineList.map((dosageGuideline, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/dosage-guideline/${dosageGuideline.id}`} color="link" size="sm">
                      {dosageGuideline.id}
                    </Button>
                  </td>
                  <td>{dosageGuideline.name}</td>
                  <td>{dosageGuideline.description}</td>
                  <td>{dosageGuideline.dosageValue}</td>
                  <td>{dosageGuideline.dosageUnit}</td>
                  <td>{dosageGuideline.recommendedDosage}</td>
                  <td>{dosageGuideline.administrationRoute}</td>
                  <td>{dosageGuideline.specialInstructions}</td>
                  <td>{dosageGuideline.asNeeded ? 'true' : 'false'}</td>
                  <td>{dosageGuideline.asNeededCondition}</td>
                  <td>{dosageGuideline.active ? 'true' : 'false'}</td>
                  <td>{dosageGuideline.cursor}</td>
                  <td>{dosageGuideline.lastUpdated}</td>
                  <td>{dosageGuideline.microSec}</td>
                  <td>{dosageGuideline.timestampEntry}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/dosage-guideline/${dosageGuideline.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/dosage-guideline/${dosageGuideline.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/dosage-guideline/${dosageGuideline.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.dosageGuideline.home.notFound">No Dosage Guidelines found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={dosageGuidelineList && dosageGuidelineList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DosageGuideline;
